import { useState } from 'react';
import { faqs } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-accent-400 font-label text-xs tracking-[0.2em] uppercase mb-3">
            常见问题
          </p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            关于073漫画网的常见疑问
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            快速了解我们的服务，解答您的疑惑
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === index
                    ? 'bg-accent-500 text-background-50 rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}